import type { IconData } from '@stacksjs/iconify-core'

export const basicUiUser: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 8a4 4 0 1 0 0-8a4 4 0 0 0 0 8m0 0a8 8 0 0 0-8 8h16a8 8 0 0 0-8-8\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiUser
